import * as types from '../types/storeSettingsTypes';

const DEFAULT_SHIPPING = {
  cjFreightMarkupPercent: 12.5,
  flatShippingRate: 15,
  freeShippingThreshold: 500,
  taxRatePercent: 8,
  applyShippingToDisplayPrice: true,
  displayPriceShippingFixedAmount: 35,
  useFixedCheckoutShipping: true,
  fixedCheckoutShipping: 10,
};

export const DEFAULT_SETTINGS = {
  name: 'Moda MAI',
  description:
    'Copenhagen-aligned studio pieces — tailoring, essentials and quieter luxury.',
  address: '',
  phone: '',
  email: '',
  shippingPricing: DEFAULT_SHIPPING,
  metaVerification: {
    google: '',
    bing: '',
    yandex: '',
    pinterest: '',
    facebook: '',
    custom: [],
  },
};

const initialState = {
  settings: null,
  loading: false,
  error: null,
};

const storeSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STORE_SETTINGS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_STORE_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: action.payload ?? DEFAULT_SETTINGS,
        error: null,
      };
    case types.FETCH_STORE_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload ?? null,
        settings: DEFAULT_SETTINGS,
      };
    default:
      return state;
  }
};

export default storeSettingsReducer;
